import React, { useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { FaPaperPlane, FaTrash } from "react-icons/fa";
import Select from "../../../components/Select";

import Container from "../../../components/Admin/Container";
import Input, { Switch } from "../../../components/Input";
import Label from "../../../components/Label";
import Button from "../../../components/Button";
import ButtonsGrid from "../../../components/ButtonsGrid";
import Form from "../../../components/Form";

import api from "../../../service/api";

import useLoading from "../../../hooks/useLoading";

import Notification from "../../../modules/Notifications";
import Confirm from "../../../modules/AlertConfirm";
import useAccess from "../../../hooks/useAccess";

const Index = (props) => {
    const { id } = props.match.params;

    const history = useHistory();

    const [data, setData] = useState({});

    const { loading } = useLoading();

    const { accesses } = useAccess();

    useEffect(() => {
        async function show() {
            const idLoading = loading();

            const response = await api.get(`/users/${id}`);

            setData({
                ...response.data,
                role: response.data.role
                    ? {
                          value: response.data.role.id,
                          label: response.data.role.name,
                      }
                    : null,
            });

            loading(idLoading);
        }

        if (id) show();
    }, [id, loading]);

    async function create() {
        const idLoading = loading();

        try {
            const serializedData = {
                ...data,
                role: data.role.value,
            };

            await api.post("/users", { ...serializedData, blocked: false });

            Notification("success", "Usuário cadastrado");

            history.push("/ctop/usuarios");

            loading(idLoading);
        } catch (error) {
            Error(error);

            loading(idLoading);
        }
    }

    async function update() {
        const idLoading = loading();

        try {
            const serializedData = {
                ...data,
                role: data.role.value,
            };

            await api.put(`/users/${id}`, serializedData);

            Notification("success", "Usuário atualizado");

            loading(idLoading);

            history.push("/ctop/usuarios");
        } catch (error) {
            Error(error);

            Notification(
                "error",
                "Erro ao atualizar usuário: " + error.message,
            );

            loading(idLoading);
        }
    }

    const destroy = async (event) => {
        event.preventDefault();

        Confirm(
            "Remover Usuário",
            "Tem certeza que deseja remover ?",
            async () => {
                const idLoading = loading();
                try {
                    await api.delete(`/users/${id}`);

                    Notification("success", "Usuário removido");

                    loading(idLoading);

                    history.push("/ctop/usuarios");
                } catch (error) {
                    Error(error);

                    loading(idLoading);
                }
            },
        );
    };

    const handleValidate = () => {
        if (!data.username) {
            return { status: false, message: "Nome de usuário é obrigatório" };
        }

        if (!data.role) {
            return { status: false, message: "Acesso é obrigatório" };
        }

        if (!data.password && !id) {
            return { status: false, message: "Senha é obrigatório" };
        }

        return { status: true };
    };

    const submit = (event) => {
        event.preventDefault();

        const validate = handleValidate();
        if (!validate.status) {
            return Notification("warning", validate.message);
        }

        if (!id) {
            return create();
        }

        return update();
    };

    return (
        <Container pageTitle={`${!id ? "Cadastrar" : "Editar"} Usuário`}>
            <Form onSubmit={submit}>
                <Input
                    type="text"
                    label="Usuário*"
                    value={data.username}
                    onChange={(event) => {
                        setData({
                            ...data,
                            username: event.target.value,
                        });
                    }}
                />

                <Label>
                    Acesso
                    <Select
                        value={data.role}
                        onChange={(v) => {
                            setData({
                                ...data,
                                role: v,
                            });
                        }}
                        options={accesses.filter(({ value }) =>
                            [1, 4].includes(value),
                        )}
                        // error={!!errors.access}
                    />
                </Label>

                <Input
                    type="text"
                    label="Senha*"
                    value={data.password}
                    onChange={(event) => {
                        setData({
                            ...data,
                            password: event.target.value,
                        });
                    }}
                />

                {id && (
                    <Col sm="12" className="d-flex justify-center">
                        <Switch
                            checked={!data.blocked}
                            label="Ativo"
                            id="blocked"
                            onChange={(event) => {
                                setData({
                                    ...data,
                                    blocked: !event.target.checked,
                                });
                            }}
                        />
                    </Col>
                )}
                <ButtonsGrid>
                    <Button className="button" type="submit" variant="success">
                        <FaPaperPlane />
                        Enviar
                    </Button>
                    {id && (
                        <Button variant="outline-danger" onClick={destroy}>
                            <FaTrash />
                            Remover
                        </Button>
                    )}
                </ButtonsGrid>
            </Form>
        </Container>
    );
};

export default Index;
